import React, { useCallback, useEffect, useRef, useState } from "react";
import DelistingForm from "./DelistingForm";
import AuthorizationForm from "./AuthorizationForm";
import SignupForm from "./SignupForm";
import { fetchSessionEmailAddress } from "./backendClientRequests";

export function DelistingPage() {
  const { activeSessionEmail, syncSessionState } = useSessionTrackingHook();
  const [email, setEmail] = useState(undefined);
  const [adminEmails, setAdminEmails] = useState([]);
  const [showDelistingSubmittedMessage, setShowDelistingSubmittedMessage] =
    useState(false);

  if (showDelistingSubmittedMessage) {
    return <DelistingReportSentNotification email={activeSessionEmail} />;
  }

  if (activeSessionEmail != null) {
    return (
      <DelistingForm
        email={activeSessionEmail}
        onSuccessfullySent={() => setShowDelistingSubmittedMessage(true)}
      />
    );
  } else if (email != null && adminEmails.length > 0) {
    return (
      <SignupForm
        email={email}
        adminAddressList={adminEmails}
        onExit={() => {
          setAdminEmails([]);
        }}
      />
    );
  }

  return (
    <AuthorizationForm
      onAuthorizationComplete={syncSessionState}
      email={email}
      setEmail={setEmail}
      onShowSignupForm={(adminEmails) => {
        setAdminEmails(adminEmails);
      }}
    />
  );
}

function useSessionTrackingHook() {
  const [activeSessionEmail, setActiveSessionEmail] = useState(undefined);

  const syncSessionState = useCallback(async (expextedMockResponse) => {
    return fetchSessionEmailAddress(expextedMockResponse).then(
      (emailAddress) => {
        setActiveSessionEmail(emailAddress);
        return emailAddress;
      },
    );
  }, []);

  // Initial session check
  useEffect(() => {
    syncSessionState(undefined);
  }, []);

  return { activeSessionEmail, syncSessionState };
}

export function DelistingReportSentNotification({ email }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    dialogRef?.current?.open();
  }, [dialogRef?.current]);

  return (
    <sdx-dialog
      notification-type={"confirmation"}
      label={"Request sent!"}
      ref={dialogRef}
      type="modal"
    >
      <sdx-dialog-content class="text-align-center">
        <p
          className="text-align-center margin-bottom-4"
          style={{ maxWidth: "500px" }}
        >
          Your delisting request has been sent. You will receive a confirmation
          email at <i>{email}</i>.
        </p>
      </sdx-dialog-content>
    </sdx-dialog>
  );
}
